import type { InjectionKey, MaybeRef } from 'vue';

/** The host app supplies its reactive locale text; the UI kit has no ERP/i18n-store dependency. */
export const selectPlaceholderKey: InjectionKey<MaybeRef<string>> = Symbol('jervis.selectPlaceholder');
